/* ---------------------------------------------------------------------------------------------------------------------
   DELCUBE: ANFRAGE-APP (seit 22.10.2026, als Section seit 23.10.2026)
   ---------------------------------------------------------------------------------------------------------------------
   Markup: snippets/dc-ask.liquid (Overlay), sections/dc-ask-section.liquid (Section), gemeinsamer Inhalt
   snippets/dc-ask-body.liquid · Fragen: snippets/dc-ask-flows.liquid · Aussehen: assets/dc-ask.css

   A. App-Kern (createApp)  Ablauf, Prüfen und Senden für eine Instanz. Läuft im Overlay und in jeder Section.
      Ablauf     Pfad aus Bereich, Fragen (mit when-Bedingungen) und Kontakt. Antworten nur im Arbeitsspeicher; ändert
                 sich eine frühere Antwort, fallen nur die Antworten weg, deren Frage nicht mehr im Pfad liegt.
      Senden     Über das echte Shopify-Kontaktformular der Instanz: Antworten als contact[…]-Felder, Shopifys hCaptcha
                 holt das Token und ruft danach form.submit() auf, das hier per fetch an /contact schickt. Erfolg gilt
                 erst, wenn Shopify mit contact_posted=true antwortet. Fragt Shopify oder Cloudflare nach einer
                 Bestätigung, wird das Formular normal abgeschickt und die App zeigt nach der Rückkehr das Ergebnis.
   B. Overlay     Klick auf einen Link zur Kontaktseite (außer Menü und Footer) oder auf [data-dc-ask]: die Fläche wächst
                 aus dem Button (clip-path), Schließen spielt es rückwärts. „Bewegung reduzieren“: nur Überblenden.
   C. Section     Beim Scrollen wächst der Button der Section zur Vollbild-App (Scroll steuert clip-path), die App bleibt
                 eine Strecke stehen, dann scrollt sie weg und der Footer kommt. „Bewegung reduzieren“: App steht offen.
   ------------------------------------------------------------------------------------------------------------------ */
(() => {
  if (window.__dcAsk) return;
  window.__dcAsk = true;

  let CFG = null;
  let L = {};
  try {
    CFG = JSON.parse(document.getElementById('dc-ask-flows').textContent);
    // Texte in der Sprache der Seite (snippets/dc-ask.liquid aus locales/*.json, Abschnitt dc.ask)
    L = JSON.parse(document.getElementById('dc-ask-i18n').textContent);
  } catch (e) { /* ohne Fragen: Links führen wie bisher zur Kontaktseite */ }
  if (!CFG) return;
  const tx = (k, vars) => String(L[k] || '').replace(/\{(\w+)\}/g, (m, n) => (vars && vars[n] != null ? vars[n] : m));

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const EASE_OUT = 'cubic-bezier(.16, 1, .3, 1)'; // --dc-ease-out
  const EASE_MORPH = 'cubic-bezier(.32, 0, .07, 1)'; // langsamer Start, langes Auslaufen: die Fläche „löst“ sich vom Button
  const MIN_TEXT = 10;
  const MAX_TEXT = 2000;
  const KIND_BY_PARAM = { '3d-druck': '3d-druck', '3d-visuals': '3d-visuals', produkte: 'allgemein:Produkte', sonstiges: 'allgemein:Sonstiges' };
  const CHECK = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M3 8.5l3.2 3.2L13 4.8" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const START = Object.assign({ start: true }, CFG.start);
  const CONTACT = { id: '_contact', type: 'contact' };
  const MAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  const vals = (a) => (Array.isArray(a) ? a : a == null || a === '' ? [] : [a]);
  const el = (tag, cls, text) => {
    const n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  };
  const umlaut = (h) => h.classList.toggle('dc-uml', /[ÄÖÜäöü]/.test(h.textContent));
  // Messpunkte der App (Shopify-Kundenereignisse wie dc_anfrage_* in dc-studio.js, nie Formularinhalte).
  // dc_anfrage_start, dc_anfrage_schritt, dc_anfrage_abgeschickt, dc_anfrage_gesendet mit Anfrageart, Quelle, Produkt.
  const pub = (name, data, tries = 0) => {
    if (!tries) (window.__dcTrack = window.__dcTrack || []).push({ name, data });
    const a = window.Shopify && window.Shopify.analytics;
    if (a && typeof a.publish === 'function') { try { a.publish(name, data); } catch (e) { /* Messung darf nie stören */ } return; }
    if (tries < 20) setTimeout(() => pub(name, data, tries + 1), 500);
  };
  // Produkt-Schlüssel aus ?produkt= (Produktkarten): nur klein, Ziffern, Bindestrich
  const cleanKey = (v) => (/^[a-z0-9-]{1,40}$/.test(String(v || '').trim().toLowerCase()) ? String(v).trim().toLowerCase() : '');
  const captcha = () => (window.Shopify && window.Shopify.captcha && typeof window.Shopify.captcha.protect === 'function' ? window.Shopify.captcha : null);

  /* =====================================================================================================================
     A. App-Kern
     root: Element mit data-dc-ask-id (Vorsilbe der IDs) · form: das Shopify-Kontaktformular darin
     opts.active(): ob die App gerade bedienbar ist · opts.onClose(): Schließen (Overlay)
     ================================================================================================================== */
  const createApp = (root, form, opts) => {
    const P = root.getAttribute('data-dc-ask-id') || 'dc-ask';
    const q = (sel, scope = root) => scope.querySelector(sel);
    const stage = q('[data-dc-ask-stage]');
    const stepEl = q('[data-dc-ask-step]');
    const contactEl = q('[data-dc-ask-contact]');
    const doneEl = q('[data-dc-ask-done]');
    const foot = q('[data-dc-ask-foot]');
    const btnBack = q('[data-dc-ask-back]');
    const btnNext = q('[data-dc-ask-next]');
    const btnSend = q('[data-dc-ask-send]');
    const sendLabel = q('[data-dc-ask-send-label]');
    const fieldsEl = q('[data-dc-ask-fields]');
    const alertEl = q('[data-dc-ask-alert]');
    const statusEl = q('[data-dc-ask-status]');
    const countEl = q('[data-dc-ask-count]');
    const inName = q('[data-dc-ask-name]');
    const inMail = q('[data-dc-ask-mail]');
    const inPrivacy = q('[data-dc-ask-privacy]');
    const MAIL = root.getAttribute('data-mail') || '';
    const ARROW = (q('.dc-ask__dot svg') || {}).outerHTML || '';
    const ID = (s) => P + '-' + s;

    const S = {
      entry: 'start', // start oder fester Bereich
      entryKey: null,
      flow: null,
      kind: '',
      answers: {},
      i: 0,
      mode: 'step', // step | contact | done
      sending: false,
      resubmit: false,
      capTimer: 0,
      advTimer: 0,
      stepAnim: null,
      produkt: '', // Schlüssel der Produktkarte (?produkt=), geht als „Produkt“ mit
      quelle: '', // qr (gedruckter Code /?anfrage=1) oder utm_source, geht als „Quelle“ mit
      doneFlow: null, // Bereich der gesendeten Anfrage, für den Abschluss
    };

    const passes = (w) => {
      if (!w) return true;
      const v = vals(S.answers[w.q]);
      if (w.in) return v.some((x) => w.in.includes(x));
      if (w.not) return !v.some((x) => w.not.includes(x));
      return true;
    };
    const flowDef = () => (S.flow ? CFG.flows[S.flow] : null);
    const path = () => {
      const list = [];
      if (S.entry === 'start') list.push(START);
      const f = flowDef();
      if (f) f.steps.forEach((s) => { if (passes(s.when)) list.push(s); });
      if (f) list.push(CONTACT);
      return list;
    };
    const visibleOptions = (step) => step.options.filter((o) => passes(o.when));

    // Antworten, deren Frage oder Antwort nicht mehr gilt, fallen weg. Wiederholt, weil Bedingungen aufeinander aufbauen.
    const prune = () => {
      for (let n = 0; n < 4; n += 1) {
        const live = new Map(path().filter((s) => s.id).map((s) => [s.id, s]));
        let changed = false;
        Object.keys(S.answers).forEach((id) => {
          const s = live.get(id);
          if (!s) { delete S.answers[id]; changed = true; return; }
          if (s.options) {
            const ok = visibleOptions(s).map((o) => o.v);
            const kept = vals(S.answers[id]).filter((v) => ok.includes(v));
            if (kept.length !== vals(S.answers[id]).length) {
              changed = true;
              if (s.type === 'multi') S.answers[id] = kept; else delete S.answers[id];
            }
          }
        });
        if (!changed) break;
      }
    };

    // Produkt aus der Karte: wählt die passende Antwort der ersten Frage vor (nur, wenn noch keine gewählt ist)
    const preselect = () => {
      const p = S.flow && CFG.flows[S.flow].produkt;
      if (!p || !S.produkt || !p.map[S.produkt] || S.answers[p.step] != null) return;
      S.answers[p.step] = p.map[S.produkt];
    };

    const setFlow = (key) => {
      const [flow, kind] = key.split(':');
      if (!CFG.flows[flow]) return;
      if (S.flow !== flow) {
        S.flow = flow;
        prune();
        preselect();
      }
      S.kind = kind || CFG.flows[flow].kind;
    };

    // Gleicher Einstieg wie beim letzten Mal und noch nicht gesendet: dort weitermachen. Sonst frisch beginnen
    // (Name und E-Mail bleiben stehen). ctx: { produkt, quelle } aus Link oder Adresse.
    const start = (entry, force, ctx = {}) => {
      const produkt = cleanKey(ctx.produkt);
      const resume = !force && entry === S.entryKey && produkt === S.produkt && S.mode !== 'done' && Object.keys(S.answers).length > 0;
      S.entryKey = entry;
      S.entry = entry === 'start' ? 'start' : 'flow';
      if (ctx.quelle) S.quelle = String(ctx.quelle).slice(0, 40);
      if (!resume) {
        S.answers = {};
        S.flow = null;
        S.kind = '';
        S.i = 0;
        S.mode = 'step';
        S.doneFlow = null;
        S.produkt = produkt;
        if (entry !== 'start') setFlow(entry);
        // Die Section bereitet die App beim Laden vor: das ist noch kein Start (silent)
        if (!ctx.silent) pub('dc_anfrage_start', { einstieg: entry, anfrageart: S.kind || 'offen', quelle: S.quelle || 'seite', produkt: S.produkt || '', seite: location.pathname });
      }
      alertEl.hidden = true;
    };

    /* ---------- Darstellung ---------- */
    const placeholder = (step) => {
      const ph = step.ph || {};
      const a = ph.from ? S.answers[ph.from] : null;
      return (ph.map && a && ph.map[a]) || ph.default || '';
    };

    const buildStep = (step) => {
      stepEl.textContent = '';
      const head = el('div', 'dc-ask__head');
      const h = el('h2', 'dc-ask__q', step.q);
      h.tabIndex = -1;
      h.id = ID('q');
      umlaut(h);
      head.append(h);
      if (step.sub) { const p = el('p', 'dc-ask__sub', step.sub); p.id = ID('sub'); head.append(p); }
      const body = el('div', 'dc-ask__body');
      const err = el('p', 'dc-ask__err');
      err.id = ID('step-err');
      err.hidden = true;
      err.setAttribute('role', 'alert');
      err.setAttribute('data-dc-ask-step-err', '');

      if (step.type === 'choice' || step.type === 'multi') {
        const multi = step.type === 'multi';
        const group = el('div', 'dc-ask__opts' + (multi ? ' dc-ask__opts--multi' : ''));
        group.setAttribute('role', multi ? 'group' : 'radiogroup');
        group.setAttribute('aria-labelledby', ID('q'));
        group.setAttribute('aria-describedby', (step.sub ? ID('sub') + ' ' : '') + ID('step-err'));
        const chosen = vals(S.answers[step.id]);
        visibleOptions(step).forEach((o, k) => {
          const lab = el('label', 'dc-ask__opt' + (o.minor ? ' dc-ask__opt--minor' : ''));
          const inp = document.createElement('input');
          inp.type = multi ? 'checkbox' : 'radio';
          inp.name = ID('o-' + step.id);
          inp.value = o.v;
          inp.id = ID('o-' + step.id + '-' + k);
          inp.setAttribute('form', 'dc-ask-none');
          inp.checked = chosen.includes(o.v);
          lab.classList.toggle('is-on', inp.checked);
          const txt = el('span', 'dc-ask__opt-text');
          txt.append(el('span', 'dc-ask__opt-l', o.l || o.v));
          if (o.h) txt.append(el('span', 'dc-ask__opt-h', o.h));
          // Kurzfassung nur am Handy (dort ist der Hinweis ausgeblendet), z. B. der Richtpreis „ab 15 €“
          if (o.hs) txt.append(el('span', 'dc-ask__opt-hs', o.hs));
          const mark = el('span', 'dc-ask__mark');
          mark.setAttribute('aria-hidden', 'true');
          mark.innerHTML = multi ? CHECK : ARROW;
          lab.append(inp, txt, mark);
          group.append(lab);
        });
        body.append(group, err);
        // Hinweis bei bestimmten Antworten (z. B. PLA und Wärme): steht unter den Antworten, solange eine solche gewählt ist
        if (step.warn) {
          const w = el('p', 'dc-ask__warn', step.warn);
          w.id = ID('warn');
          w.setAttribute('aria-live', 'polite');
          w.hidden = !visibleOptions(step).some((o) => o.warn && chosen.includes(o.v));
          group.setAttribute('aria-describedby', group.getAttribute('aria-describedby') + ' ' + w.id);
          body.append(w);
        }
        if (step.note) body.append(el('p', 'dc-ask__note', step.note));
      } else if (step.type === 'text') {
        const wrap = el('div', 'dc-ask__area' + (step.rows ? ' dc-ask__area--short' : ''));
        const ta = document.createElement('textarea');
        ta.className = 'dc-ask__text';
        ta.id = ID('text');
        ta.rows = step.rows || 5;
        ta.maxLength = MAX_TEXT;
        ta.setAttribute('form', 'dc-ask-none');
        ta.setAttribute('aria-labelledby', ID('q'));
        ta.setAttribute('aria-describedby', (step.sub ? ID('sub') + ' ' : '') + ID('step-err'));
        ta.placeholder = placeholder(step);
        ta.value = S.answers[step.id] || '';
        const len = el('span', 'dc-ask__len', ta.value.length + ' / ' + MAX_TEXT);
        len.setAttribute('aria-hidden', 'true');
        wrap.append(ta, len);
        body.append(wrap, err);
      }
      stepEl.append(head, body);
      return stepEl;
    };

    const summary = () => {
      const out = [];
      const f = flowDef();
      if (f && f.label && S.flow !== 'allgemein') out.push(f.label);
      // Anzeige in der Sprache der Seite: s (kurze Beschriftung) bzw. kinds; gesendet werden die deutschen Werte (v)
      if (S.flow === 'allgemein' && S.kind && S.kind !== 'Sonstiges') out.push((CFG.kinds && CFG.kinds[S.kind]) || S.kind);
      path().forEach((s) => {
        if (s.start || !s.options) return;
        const v = vals(S.answers[s.id]);
        if (v.length) out.push(v.map((x) => (s.options.find((o) => o.v === x) || {}).s || x).join(', '));
      });
      return out;
    };

    const buildContact = () => {
      const h = q('[data-dc-ask-q]', contactEl);
      h.textContent = CFG.contact.q;
      umlaut(h);
      const csub = q('[data-dc-ask-sub]', contactEl);
      csub.textContent = CFG.contact.sub || '';
      csub.hidden = !CFG.contact.sub;
      const sum = q('[data-dc-ask-sum]', contactEl);
      sum.textContent = '';
      summary().forEach((t) => sum.append(el('li', '', t)));
      // Hinweis auf hCaptcha direkt am Formular. Shopify lässt dann sein schwebendes Abzeichen weg (das hier verdeckt wäre).
      const cap = q('[data-dc-ask-cap]', contactEl);
      if (!cap.firstChild) {
        const p = el('p', 'dc-ask__cap');
        p.setAttribute('data-spam-detection-disclaimer', '');
        p.innerHTML = tx('captcha_html');
        cap.append(p);
      }
      return contactEl;
    };

    const buildDone = () => {
      const name = (inName.value || '').trim().split(/\s+/)[0];
      // Eigener Abschluss je Bereich (z. B. 3D-Druck: Radek meldet sich, dazu der Hinweis zu Fotos und Dateien)
      const D = (S.doneFlow && CFG.flows[S.doneFlow] && CFG.flows[S.doneFlow].done) || CFG.done;
      const h = q('[data-dc-ask-q]', doneEl);
      h.textContent = name && D.q_name ? D.q_name.replace('{name}', name) : D.q;
      umlaut(h);
      const sub = q('[data-dc-ask-sub]', doneEl);
      sub.textContent = D.sub || '';
      sub.hidden = !D.sub;
      let files = q('.dc-ask__files', doneEl);
      if (!files) { files = el('p', 'dc-ask__files'); sub.after(files); }
      files.textContent = D.files || '';
      files.hidden = !D.files;
      return doneEl;
    };

    // Zeigt den aktuellen Schritt (ohne Animation) und liefert sein Element
    const render = () => {
      const list = path();
      let shown;
      if (S.mode === 'done') shown = buildDone();
      else {
        if (S.i > list.length - 1) S.i = Math.max(0, list.length - 1);
        const step = list[S.i];
        S.mode = step.type === 'contact' ? 'contact' : 'step';
        shown = S.mode === 'contact' ? buildContact() : buildStep(step);
      }
      [stepEl, contactEl, doneEl].forEach((n) => { n.hidden = n !== shown; });
      // hCaptcha erst im Kontakt-Schritt binden, und zwar bevor jemand in die Felder tippt (sonst bindet Shopify selbst
      // und legt beim Senden eine Kopie der Anfrage im sessionStorage ab)
      if (S.mode === 'contact') bindCaptcha().catch(() => {});

      // Fortschritt nur als Schrittzahl oben rechts
      const total = list.length;
      const nr = Math.min(S.i + 1, total);
      countEl.textContent = S.mode === 'done' || !flowDef() ? '' : nr + ' / ' + total;

      foot.hidden = S.mode === 'done';
      btnBack.classList.toggle('is-gone', S.i === 0);
      btnBack.tabIndex = S.i === 0 ? -1 : 0;
      btnBack.setAttribute('aria-hidden', String(S.i === 0));
      btnNext.hidden = S.mode !== 'step';
      btnSend.hidden = S.mode !== 'contact';
      stage.scrollTop = 0;
      return shown;
    };

    const announce = () => {
      const list = path();
      statusEl.textContent = S.mode === 'done' ? tx('sent') : flowDef() ? tx('step_of', { n: S.i + 1, total: list.length }) : '';
    };

    const focusHeading = () => {
      const h = q('.dc-ask__step:not([hidden]) .dc-ask__q');
      if (h) h.focus({ preventScroll: true });
    };

    /* ---------- Schrittwechsel ---------- */
    // Teile eines Schritts nacheinander einlaufen lassen (Frage, Satz, jede Antwort, Felder)
    const parts = (shown) => {
      const list = [];
      shown.querySelectorAll(':scope > .dc-ask__head > *, :scope > .dc-ask__body > *').forEach((n) => {
        if (n.hidden) return;
        if (n.classList.contains('dc-ask__opts')) list.push(...n.children); else list.push(n);
      });
      return list;
    };
    const stagger = (shown, dir, delay, step) => parts(shown).slice(0, 12).map((n, k) => n.animate(
      [{ opacity: 0, transform: `translateY(${18 * dir}px)` }, { opacity: 1, transform: 'none' }],
      { duration: 460, delay: delay + k * step, easing: EASE_OUT, fill: 'backwards' },
    ));

    const go = (to, dir) => {
      clearTimeout(S.advTimer);
      if (S.stepAnim) { S.stepAnim.forEach((a) => a.finish()); S.stepAnim = null; }
      const from = q('.dc-ask__step:not([hidden])');
      const swap = () => {
        S.i = to;
        const shown = render();
        announce();
        focusHeading();
        // Ein Ereignis pro Bildschirm: zeigt, an welcher Frage Leute aufhören
        if (S.mode !== 'done') {
          const st = path()[S.i] || {};
          pub('dc_anfrage_schritt', { strecke: S.flow || 'start', schritt: S.i + 1, frage: st.id || st.type || '', quelle: S.quelle || 'seite', produkt: S.produkt || '' });
        }
        return shown;
      };
      if (!from || reduce.matches || !from.animate) {
        const shown = swap();
        if (from && shown.animate) shown.animate([{ opacity: 0 }, { opacity: 1 }], { duration: reduce.matches ? 120 : 200 });
        return;
      }
      const out = from.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: `translateY(${-14 * dir}px)` }], { duration: 160, easing: 'cubic-bezier(.4, 0, 1, 1)', fill: 'forwards' });
      S.stepAnim = [out];
      out.finished.then(() => {
        out.cancel();
        const shown = swap();
        S.stepAnim = stagger(shown, dir, 0, 30);
      }).catch(() => {});
    };

    /* ---------- Prüfen ---------- */
    // Kurze Felder (z. B. Link zur Datei) ohne Mindestlänge
    const minText = (step) => (step.short ? 1 : MIN_TEXT);
    const showErr = (node, input, msg) => {
      node.textContent = msg || '';
      node.hidden = !msg;
      if (input) input.setAttribute('aria-invalid', String(!!msg));
    };
    const stepErr = () => q('[data-dc-ask-step-err]', stepEl);

    const validateStep = () => {
      const step = path()[S.i];
      const err = stepErr();
      if (step.type === 'choice' || step.type === 'multi') {
        const ok = vals(S.answers[step.id]).length > 0;
        const group = q('.dc-ask__opts', stepEl);
        group.classList.toggle('is-invalid', !ok);
        showErr(err, null, ok ? '' : step.type === 'multi' ? tx('err_multi') : tx('err_choice'));
        if (!ok) { const first = q('input', group); if (first) first.focus(); }
        return ok;
      }
      if (step.type === 'text') {
        const ta = q('.dc-ask__text', stepEl);
        const v = (ta.value || '').trim();
        const min = minText(step);
        const ok = (step.optional && !v) || v.length >= min;
        showErr(err, ta, ok ? '' : tx('err_text', { min }));
        if (!ok) ta.focus();
        return ok;
      }
      return true;
    };

    const validateContact = () => {
      const name = inName.value.trim();
      const mail = inMail.value.trim();
      const checks = [
        [inName, q('#' + ID('name-err')), name ? '' : tx('err_name')],
        [inMail, q('#' + ID('email-err')), !mail ? tx('err_mail_empty') : MAIL_RE.test(mail) && inMail.checkValidity() ? '' : tx('err_mail_invalid')],
        [inPrivacy, q('#' + ID('privacy-err')), inPrivacy.checked ? '' : tx('err_privacy')],
      ];
      let first = null;
      checks.forEach(([input, node, msg]) => {
        showErr(node, input, msg);
        if (msg && !first) first = input;
      });
      if (first) first.focus();
      return !first;
    };

    const next = () => {
      if (S.mode !== 'step' || !opts.active()) return;
      if (!validateStep()) return;
      const list = path();
      if (S.i < list.length - 1) go(S.i + 1, 1);
    };
    const back = () => {
      if (!opts.active() || S.sending || S.i === 0 || S.mode === 'done') return;
      go(S.i - 1, -1);
    };

    /* ---------- Eingaben ---------- */
    let lastPointer = 0;
    stepEl.addEventListener('pointerdown', (e) => { if (e.target.closest('.dc-ask__opt')) lastPointer = performance.now(); });

    stepEl.addEventListener('change', (e) => {
      const inp = e.target;
      const step = path()[S.i];
      if (!step || !step.options || !inp.matches('.dc-ask__opt input')) return;
      clearTimeout(S.advTimer);
      if (step.type === 'multi') {
        const opt = step.options.find((o) => o.v === inp.value) || {};
        let cur = vals(S.answers[step.id]).filter((v) => v !== inp.value);
        if (inp.checked) {
          if (opt.only) cur = [];
          else cur = cur.filter((v) => !(step.options.find((o) => o.v === v) || {}).only);
          cur.push(inp.value);
        }
        S.answers[step.id] = cur;
        stepEl.querySelectorAll('.dc-ask__opt input').forEach((n) => { n.checked = cur.includes(n.value); });
      } else {
        S.answers[step.id] = inp.value;
        if (step.start) setFlow(inp.value);
      }
      prune();
      stepEl.querySelectorAll('.dc-ask__opt').forEach((lab) => lab.classList.toggle('is-on', lab.firstChild.checked));
      q('.dc-ask__opts', stepEl).classList.remove('is-invalid');
      showErr(stepErr(), null, '');
      // Antwort mit Hinweis (z. B. PLA und Wärme): Hinweis zeigen und nicht automatisch weiter, damit er gelesen wird
      const warned = !!(step.warn && (step.options.find((o) => o.v === inp.value) || {}).warn);
      const w = q('.dc-ask__warn', stepEl);
      if (w) w.hidden = !warned;
      // Antippen einer Einzel-Antwort führt weiter, sobald die Wahl sichtbar ist. Pfeiltasten wählen nur.
      if (step.type === 'choice' && !warned && performance.now() - lastPointer < 900) S.advTimer = setTimeout(next, reduce.matches ? 120 : 280);
    });

    stepEl.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' && e.target.matches('.dc-ask__opt input')) { e.preventDefault(); next(); }
      if (e.key === 'Enter' && (e.metaKey || e.ctrlKey) && e.target.matches('.dc-ask__text')) { e.preventDefault(); next(); }
    });

    stepEl.addEventListener('input', (e) => {
      if (!e.target.matches('.dc-ask__text')) return;
      const step = path()[S.i];
      S.answers[step.id] = e.target.value;
      const len = q('.dc-ask__len', stepEl);
      if (len) len.textContent = e.target.value.length + ' / ' + MAX_TEXT;
      if (e.target.getAttribute('aria-invalid') === 'true' && e.target.value.trim().length >= minText(step)) showErr(stepErr(), e.target, '');
    });

    [inName, inMail].forEach((input) => input.addEventListener('input', () => {
      if (input.getAttribute('aria-invalid') === 'true') showErr(q('#' + input.id + '-err'), input, '');
    }));
    inPrivacy.addEventListener('change', () => { if (inPrivacy.checked) showErr(q('#' + ID('privacy-err')), inPrivacy, ''); });

    btnNext.addEventListener('click', next);
    btnBack.addEventListener('click', back);
    root.querySelectorAll('[data-dc-ask-close]').forEach((b) => b.addEventListener('click', () => { if (opts.onClose) opts.onClose(); }));
    // Abschluss in der Section: eine neue Anfrage beginnt von vorn
    root.querySelectorAll('[data-dc-ask-again]').forEach((b) => b.addEventListener('click', () => {
      start(S.entryKey || 'start', true);
      go(0, 1);
    }));

    /* ---------- Senden über das Shopify-Kontaktformular ---------- */
    const fillFields = () => {
      fieldsEl.textContent = '';
      const add = (name, value) => {
        const i = document.createElement('input');
        i.type = 'hidden';
        i.name = 'contact[' + name + ']';
        i.value = value;
        fieldsEl.append(i);
      };
      add('Anfrageart', S.kind || 'Sonstiges');
      // Unsichtbar mit: Produkt der Karte und Quelle (qr bei /?anfrage=1, sonst utm_source)
      if (S.produkt) add('Produkt', S.produkt);
      if (S.quelle) add('Quelle', S.quelle);
      let body = '';
      path().forEach((s) => {
        if (s.start || !s.field) return;
        const v = vals(S.answers[s.id]);
        if (!v.length) return;
        if (s.field === 'body') body = String(v[0]).trim();
        else add(s.field, v.join(', '));
      });
      add('Bereich', 'Anfrage-App');
      add('Gestartet auf', location.pathname);
      // Anfrage von der englischen Seite: in der E-Mail sichtbar, damit auf Englisch geantwortet wird
      if (L.lang && L.lang !== 'de') add('Sprache', L.lang === 'en' ? 'Englisch' : L.lang);
      add('body', body || tx('no_desc'));
    };

    const setSending = (on) => {
      S.sending = on;
      root.classList.toggle('is-sending', on);
      btnSend.setAttribute('aria-disabled', String(on));
      sendLabel.textContent = on ? tx('sending') : tx('send');
      root.querySelectorAll('[data-dc-ask-close]').forEach((b) => b.setAttribute('aria-disabled', String(on)));
      btnBack.disabled = on;
    };

    const fail = (msg) => {
      clearTimeout(S.capTimer);
      setSending(false);
      alertEl.textContent = '';
      alertEl.append(document.createTextNode(tx('fail', { reason: msg })));
      if (MAIL) {
        alertEl.append(document.createTextNode(tx('fail_mail_pre')));
        const a = el('a', '', MAIL);
        a.href = 'mailto:' + MAIL;
        alertEl.append(a, document.createTextNode(tx('fail_mail_post')));
      } else alertEl.append(document.createTextNode('.'));
      alertEl.hidden = false;
    };

    const forget = () => {
      S.answers = {};
      S.flow = null;
      S.kind = '';
      fieldsEl.textContent = '';
      inPrivacy.checked = false;
      setTimeout(() => { inName.value = ''; inMail.value = ''; }, 600);
    };

    const track = () => ({ anfrageart: S.kind || 'Sonstiges', formular: 'anfrage-app', quelle: S.quelle || 'seite', produkt: S.produkt || '', seite: location.pathname });
    const succeed = () => {
      clearTimeout(S.capTimer);
      setSending(false);
      pub('dc_anfrage_gesendet', track());
      S.doneFlow = S.flow;
      S.mode = 'done';
      go(S.i, 1);
      // Danach ist alles vergessen: keine Antworten, keine Felder
      forget();
    };

    // Shopifys hCaptcha ruft nach dem Token form.submit() auf. Diese Funktion muss stehen, bevor Shopify das Formular bindet.
    const send = async () => {
      clearTimeout(S.capTimer);
      if (!S.sending) setSending(true);
      let res;
      const ctl = 'AbortController' in window ? new AbortController() : null;
      const timer = setTimeout(() => ctl && ctl.abort(), 30000);
      try {
        // Kodiert wie ein normal abgeschicktes Formular (urlencoded). Als multipart (FormData direkt) lehnt Shopify mit
        // „invalid parameters“ ab.
        res = await fetch(form.action, { method: 'POST', body: new URLSearchParams(new FormData(form)), credentials: 'same-origin', headers: { Accept: 'text/html' }, signal: ctl ? ctl.signal : undefined });
      } catch (e) {
        clearTimeout(timer);
        fail(tx('fail_network'));
        return;
      }
      clearTimeout(timer);
      const url = new URL(res.url, location.href);
      let doc = null;
      try { doc = new DOMParser().parseFromString(await res.text(), 'text/html'); } catch (e) { /* ohne Antworttext entscheidet die Adresse */ }
      const mine = doc && doc.getElementById(form.id);
      const title = ((doc && doc.title) || '').toLowerCase();
      // Shopify oder Cloudflare will eine sichtbare Bestätigung (Seite /challenge oder „Verifying your connection“).
      // Das geht nur im Browserfenster: klassisch absenden, die App zeigt nach der Rückkehr das Ergebnis.
      if (/\/challenge/.test(url.pathname) || (res.status === 403 && (title.includes('verif') || !!(doc && doc.querySelector('.cf-injected-html, #challenge-error-text'))))) {
        alertEl.hidden = false;
        alertEl.textContent = tx('challenge');
        setTimeout(() => HTMLFormElement.prototype.submit.call(form), 1200);
        return;
      }
      const errNode = mine && mine.querySelector('[data-dc-ask-error]');
      const posted = url.searchParams.get('contact_posted') === 'true' || !!(mine && mine.querySelector('[data-dc-ask-posted]'));
      if (res.ok && posted && !errNode) { succeed(); return; }
      // Shopify antwortet bei abgelehnten Angaben nicht mit dem Formular, sondern mit einer eigenen Fehlerseite
      if (errNode) fail(errNode.getAttribute('data-dc-ask-error').trim() + '.');
      else if (title.includes('captcha')) fail(tx('fail_captcha'));
      else if (title.includes('invalid parameters')) fail(tx('fail_params'));
      else if (res.status === 403 || res.status === 429 || title.includes('verifying')) fail(tx('fail_verify'));
      else fail(tx('fail_status', { code: res.status }));
    };
    try { form.submit = send; } catch (e) { /* sehr alte Browser: dann ohne Captcha-Weg, siehe submit */ }

    const bound = () => form.getAttribute('data-hcaptcha-bound') === 'true';
    let bindPromise = null;
    // Shopify lädt hCaptcha und bindet das Formular (erst im Kontakt-Schritt, nicht schon beim Öffnen)
    const bindCaptcha = () => {
      const cap = captcha();
      if (!cap || bound()) return Promise.resolve();
      if (!bindPromise) {
        bindPromise = new Promise((resolve, reject) => {
          const t = setTimeout(() => reject(new Error('timeout')), 15000);
          try { cap.protect(form, () => { clearTimeout(t); resolve(); }); } catch (e) { clearTimeout(t); reject(e); }
        }).catch((e) => { bindPromise = null; throw e; });
      }
      return bindPromise;
    };

    form.addEventListener('submit', (e) => {
      const stop = () => { e.preventDefault(); e.stopImmediatePropagation(); };
      if (S.resubmit) { S.resubmit = false; } else {
        if (S.mode !== 'contact' || !opts.active() || S.sending) { stop(); return; }
        alertEl.hidden = true;
        if (!validateContact()) { stop(); return; }
        fillFields();
        setSending(true);
        pub('dc_anfrage_abgeschickt', track());
      }
      const cap = captcha();
      if (!cap) { stop(); send(); return; }
      if (!bound()) {
        stop();
        bindCaptcha().then(() => { S.resubmit = true; form.requestSubmit ? form.requestSubmit(btnSend) : btnSend.click(); })
          .catch(() => fail(tx('fail_loadcap')));
        return;
      }
      // Shopify übernimmt ab hier (Token holen, dann send). Kein Weiterreichen an die Seite: so legt Shopify keine Kopie
      // der Anfrage im sessionStorage ab. Läuft die Prüfung ins Leere (Fenster geschlossen), wird der Knopf wieder frei.
      e.preventDefault();
      e.stopPropagation();
      clearTimeout(S.capTimer);
      S.capTimer = setTimeout(() => { if (S.sending) fail(tx('fail_capdone')); }, 90000);
    });

    // Seite aus dem Zurück-Cache: halbfertiges Senden zurücksetzen
    window.addEventListener('pageshow', (e) => { if (e.persisted && S.sending) fail(tx('fail_reload')); });

    // Rückkehr nach klassischem Senden (Bestätigung bei Shopify): Ergebnis aus der neu geladenen Seite
    const returned = () => {
      if (location.hash !== '#' + form.id) return null;
      const posted = !!q('[data-dc-ask-posted]', form);
      const err = q('[data-dc-ask-error]', form);
      if (!posted && !err) return null;
      try { history.replaceState(history.state, '', location.pathname + location.search.replace(/[?&]contact_posted=[^&]*/, '').replace(/^&/, '?')); } catch (e) { /* egal */ }
      if (posted) S.mode = 'done';
      return { posted, error: err ? err.getAttribute('data-dc-ask-error') : '' };
    };

    return { S, root, form, stage, foot, start, render, announce, focusHeading, stagger, fail, returned, statusEl };
  };

  /* =====================================================================================================================
     B. Overlay
     ================================================================================================================== */
  const initOverlay = () => {
    const root = document.getElementById('dc-ask');
    const form = document.getElementById('dc-ask-form');
    if (!root || !form) return;
    const q = (sel) => root.querySelector(sel);
    const surface = q('[data-dc-ask-surface]');
    const scrim = q('.dc-ask__scrim');
    const contactPath = (root.dataset.contactPath || '/pages/kontakt').replace(/\/$/, '');
    const O = { phase: 'idle', trigger: null, triggerBg: null, radius: 0, pendingClose: false, pushed: false, skipPop: false, inerted: [] };
    let close;
    const app = createApp(root, form, { active: () => O.phase === 'open' || O.phase === 'opening', onClose: () => close() });
    const S = app.S;

    const rectOf = (n) => {
      if (!n || !n.isConnected) return null;
      const r = n.getBoundingClientRect();
      if (r.width < 4 || r.height < 4 || r.bottom < 0 || r.right < 0 || r.top > window.innerHeight || r.left > window.innerWidth) return null;
      return r;
    };
    const bgOf = (n) => {
      if (!n) return null;
      const c = getComputedStyle(n).backgroundColor;
      const m = c.match(/[\d.]+/g);
      if (!m || m.length < 3) return null;
      const [r, g, b, a = 1] = m.map(Number);
      if (a < 0.6) return null;
      return { c, l: (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255 };
    };

    const vv = window.visualViewport;
    const syncViewport = () => {
      if (!vv || O.phase === 'idle') return;
      if (vv.scale > 1.01) return; // beim Zoomen mit zwei Fingern nicht nachführen
      root.style.setProperty('--a-vh', vv.height + 'px');
      root.style.setProperty('--a-vt', vv.offsetTop + 'px');
    };
    if (vv) { vv.addEventListener('resize', syncViewport); vv.addEventListener('scroll', syncViewport); }

    const setInert = (on) => {
      if (on) {
        O.inerted = [...document.body.children].filter((n) => n !== root && !n.inert && n.tagName !== 'SCRIPT');
        O.inerted.forEach((n) => { n.inert = true; });
      } else {
        O.inerted.forEach((n) => { n.inert = false; });
        O.inerted = [];
      }
    };

    const clipOf = (r, rad) => {
      const top = parseFloat(getComputedStyle(surface).top) || 0;
      const w = surface.clientWidth;
      const h = surface.clientHeight;
      return `inset(${(r.top - top).toFixed(1)}px ${(w - r.right).toFixed(1)}px ${(h - (r.bottom - top)).toFixed(1)}px ${r.left.toFixed(1)}px round ${rad.toFixed(1)}px)`;
    };
    const centerRect = () => {
      const w = Math.min(260, window.innerWidth * 0.6);
      const h = 60;
      const x = (window.innerWidth - w) / 2;
      const y = (surface.clientHeight - h) / 2;
      return { top: y, left: x, right: x + w, bottom: y + h, width: w, height: h };
    };

    const open = (trigger, entry, opts = {}) => {
      if (O.phase !== 'idle') return;
      O.phase = 'opening';
      O.pendingClose = false;
      const r = rectOf(trigger);
      const bg = bgOf(trigger);
      // Steckt der Button in einem Menü oder Drawer von Impact, schließt es (eigene Fokusfalle)
      const dlg = trigger && trigger.closest('[open]');
      if (dlg && dlg !== root && typeof dlg.hide === 'function') { try { dlg.hide(); } catch (e) { /* weiter ohne */ } }

      O.trigger = trigger || null;
      O.triggerBg = bg ? bg.c : null;
      O.radius = r ? Math.min(parseFloat(getComputedStyle(trigger).borderTopLeftRadius) || 0, r.height / 2) : 30;
      if (!opts.keep) app.start(entry, false, opts);
      root.dataset.tone = bg && bg.l > 0.55 ? 'light' : 'dark';
      root.hidden = false;
      document.documentElement.classList.add('dc-ask-lock');
      syncViewport();
      setInert(true);
      const shown = app.render();
      app.announce();
      if (!O.pushed) { try { history.pushState({ dcAsk: true }, ''); O.pushed = true; } catch (e) { /* ohne Verlauf */ } }

      const finish = () => {
        O.phase = 'open';
        app.focusHeading();
        if (O.pendingClose) close();
      };
      if (reduce.matches || !surface.animate) {
        const a = root.animate ? root.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 180, easing: 'ease-out' }) : null;
        if (a) a.finished.then(finish, finish); else finish();
        return;
      }
      const end = getComputedStyle(surface).backgroundColor;
      const box = r || centerRect();
      const D = r ? 640 : 520;
      // Ecken bleiben bis kurz vor Schluss rund (Bühnen-Radius), erst die letzte Strecke wird eckig
      const late = 0.84;
      const mid = { top: box.top * (1 - late), left: box.left * (1 - late), right: window.innerWidth - (window.innerWidth - box.right) * (1 - late), bottom: surface.clientHeight - (surface.clientHeight - box.bottom) * (1 - late) };
      const morph = surface.animate([
        { clipPath: clipOf(box, O.radius), backgroundColor: O.triggerBg || end, opacity: 0 },
        { opacity: 1, offset: r ? 0.14 : 0.3 },
        { clipPath: clipOf(mid, 28), offset: late },
        { clipPath: 'inset(0px 0px 0px 0px round 0px)', backgroundColor: end, opacity: 1 },
      ], { duration: D, easing: EASE_MORPH });
      scrim.animate([{ opacity: 0 }, { opacity: 1 }], { duration: D * 0.8, easing: 'ease-out' });
      // Kopf und Knöpfe, dann die Frage mit ihren Antworten: setzen ein, wenn die Fläche fast steht
      const chrome = [q('.dc-ask__top'), app.foot].filter((n) => n && !n.hidden);
      chrome.forEach((n, k) => n.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 380, delay: D * 0.45 + k * 40, easing: 'ease-out', fill: 'backwards' }));
      app.stagger(shown, 1, D * 0.42, 38);
      morph.finished.then(finish, finish);
    };

    close = (opts = {}) => {
      if (O.phase === 'opening') { O.pendingClose = true; return; }
      if (O.phase !== 'open') return;
      if (S.sending && !opts.force) return;
      O.phase = 'closing';
      clearTimeout(S.advTimer);
      if (S.stepAnim) { S.stepAnim.forEach((a) => a.finish()); S.stepAnim = null; }
      if (O.pushed && !opts.fromHistory) { O.pushed = false; O.skipPop = true; try { history.back(); } catch (e) { /* egal */ } }
      if (opts.fromHistory) O.pushed = false;

      const done = () => {
        if (root.getAnimations) root.getAnimations({ subtree: true }).forEach((a) => a.cancel());
        root.hidden = true;
        document.documentElement.classList.remove('dc-ask-lock');
        root.style.removeProperty('--a-vh');
        root.style.removeProperty('--a-vt');
        setInert(false);
        const cap = q('[data-dc-ask-cap]');
        if (cap) cap.textContent = '';
        O.phase = 'idle';
        if (S.mode === 'done') { S.mode = 'step'; S.i = 0; }
        const t = O.trigger;
        if (t && t.isConnected && rectOf(t)) t.focus({ preventScroll: true });
        O.trigger = null;
      };
      if (reduce.matches || !surface.animate) {
        const a = root.animate ? root.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 160, easing: 'ease-in', fill: 'forwards' }) : null;
        if (a) a.finished.then(done, done); else done();
        return;
      }
      const r = rectOf(O.trigger);
      const end = getComputedStyle(surface).backgroundColor;
      form.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 140, easing: 'ease-in', fill: 'forwards' });
      const D = r ? 520 : 420;
      const shrink = surface.animate([
        { clipPath: 'inset(0px 0px 0px 0px round 0px)', backgroundColor: end, opacity: 1 },
        { opacity: 1, offset: r ? 0.8 : 0.4 },
        { clipPath: clipOf(r || centerRect(), r ? O.radius : 30), backgroundColor: (r && O.triggerBg) || end, opacity: 0 },
      ], { duration: D, delay: 60, easing: 'cubic-bezier(.55, 0, .1, 1)', fill: 'forwards' });
      scrim.animate([{ opacity: 1 }, { opacity: 0 }], { duration: D, delay: 60, easing: 'ease-in-out', fill: 'forwards' });
      shrink.finished.then(done, done);
    };

    window.addEventListener('popstate', () => {
      if (O.skipPop) { O.skipPop = false; return; }
      if (O.phase === 'open' || O.phase === 'opening') {
        if (S.sending) { try { history.pushState({ dcAsk: true }, ''); O.pushed = true; } catch (e) { /* egal */ } return; }
        close({ fromHistory: true });
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && (O.phase === 'open' || O.phase === 'opening') && !e.defaultPrevented) { e.preventDefault(); close(); }
    });

    const entryOf = (a) => {
      if (a.hasAttribute('data-dc-ask')) return a.getAttribute('data-dc-ask') || 'start';
      if (a.tagName !== 'A' || a.hasAttribute('download')) return null;
      if (a.target && a.target !== '_self') return null;
      // Menüpunkte (Kopf, Handy-Menü) und Footer bleiben Links zur Kontaktseite, nur Aufrufe öffnen die App
      if (a.closest('footer, .footer, nav, navigation-drawer li, [data-dc-ask-skip], #dc-ask, .shopify-section-group-footer-group')) return null;
      let u;
      try { u = new URL(a.href, location.href); } catch (e) { return null; }
      if (u.origin !== location.origin || u.pathname.replace(/\/$/, '') !== contactPath) return null;
      const k = (u.searchParams.get('anfrage') || '').toLowerCase().trim();
      return KIND_BY_PARAM[k] || 'start';
    };

    document.addEventListener('click', (e) => {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      if (window.Shopify && window.Shopify.designMode) return;
      const a = e.target.closest && e.target.closest('a[href], [data-dc-ask]');
      if (!a) return;
      const entry = entryOf(a);
      if (!entry) return;
      // Stil noch nicht geladen (sehr früher Klick): normaler Link zur Kontaktseite
      if (getComputedStyle(root).position !== 'fixed') return;
      e.preventDefault();
      // Produktkarten hängen ?produkt=<Schlüssel> an (oder data-dc-produkt an Buttons): wählt die erste Antwort vor
      let produkt = a.getAttribute('data-dc-produkt') || '';
      if (!produkt && a.tagName === 'A') { try { produkt = new URL(a.href, location.href).searchParams.get('produkt') || ''; } catch (err) { /* ohne */ } }
      open(a, entry, { produkt });
    });

    const back = app.returned();
    if (back) {
      const show = () => {
        S.entry = 'start';
        if (!back.posted) { S.mode = 'step'; S.i = 0; }
        open(null, 'start', { keep: true });
        if (back.error) app.statusEl.textContent = tx('returned_error', { reason: back.error });
      };
      if (document.readyState === 'complete') show(); else window.addEventListener('load', show, { once: true });
    }

    // Deep Links (Mails, Anzeigen, Social, gedruckte QR-Codes). FESTE REGEL: /?anfrage=1 steht auf Werbetafeln und muss
    // immer die Anfrage öffnen; der Parameter wird nie umbenannt.
    //   ?anfrage=1                     Startbildschirm (Bereich wählen), Quelle qr (oder utm_source, falls gesetzt)
    //   ?anfrage=3d-druck | 3d-visuals | produkte | sonstiges   direkt in diesen Bereich, Quelle aus utm_source
    //   &produkt=<Schlüssel>           Produkt vorausgewählt (z. B. ersatzteil)
    // anfrage und produkt werden danach aus der Adresse genommen, damit Schließen und Neuladen die Seite normal zeigen;
    // utm_* bleiben für die Auswertung stehen. Nicht auf der Kontaktseite (eigenes Formular) und nicht im Theme-Editor.
    const sp = new URLSearchParams(location.search);
    const k = (sp.get('anfrage') || '').toLowerCase().trim();
    const deepEntry = k === '1' ? 'start' : KIND_BY_PARAM[k];
    if (deepEntry && !back && !(window.Shopify && window.Shopify.designMode) && location.pathname.replace(/\/$/, '') !== contactPath) {
      const quelle = (sp.get('utm_source') || (k === '1' ? 'qr' : '')).replace(/[^\w.-]/g, '').slice(0, 40);
      const produkt = sp.get('produkt') || '';
      const show = () => {
        try {
          const u = new URL(location.href);
          u.searchParams.delete('anfrage');
          u.searchParams.delete('produkt');
          history.replaceState(history.state, '', u.pathname + u.search + u.hash);
        } catch (e) { /* egal */ }
        open(null, deepEntry, { produkt, quelle });
      };
      if (document.readyState === 'complete') show(); else window.addEventListener('load', show, { once: true });
    }
  };

  /* =====================================================================================================================
     Halftone der Section (Canvas, scharf in Gerätepixeln). Werte aus Theme-Einstellungen > DELCUBE Halftone:
     --dc-ht-size (Handy: --dc-ht-size-sm), --dc-ht-strength, aus bei html[data-dc-halftone="off"].
     Runde Punkte in versetzten Reihen. Größe nimmt mit dem Abstand ab, jeder Punkt hat eine feste kleine Abweichung,
     außen fallen einzelne Punkte weg, die Breite schwankt sanft entlang der Kante. Dezent: wenig Deckkraft.
     ================================================================================================================== */
  const htOn = () => document.documentElement.getAttribute('data-dc-halftone') !== 'off';
  const htNum = (name, d) => { const n = parseFloat(getComputedStyle(document.documentElement).getPropertyValue(name)); return Number.isFinite(n) ? n : d; };
  const htHash = (x, y) => {
    let h = (Math.imul(x, 374761393) + Math.imul(y, 668265263)) | 0;
    h = Math.imul(h ^ (h >>> 13), 1274126177);
    return ((h ^ (h >>> 16)) >>> 0) / 4294967295;
  };
  const htFit = (cv) => {
    const dpr = Math.min(2, window.devicePixelRatio || 1);
    const w = cv.clientWidth;
    const h = cv.clientHeight;
    if (cv.width !== Math.round(w * dpr) || cv.height !== Math.round(h * dpr)) { cv.width = Math.round(w * dpr); cv.height = Math.round(h * dpr); }
    const ctx = cv.getContext('2d');
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    ctx.clearRect(0, 0, w, h);
    return { ctx, w, h };
  };
  const htPitch = (w) => (w < 700 ? htNum('--dc-ht-size-sm', 4) * 1.9 : htNum('--dc-ht-size', 7) * 1.55);
  const htWobble = (x, y) => 0.7 + 0.3 * Math.sin(x * 0.021 + y * 0.013) * Math.cos(x * 0.008 - y * 0.017 + 1.3);
  // Abstand eines Punkts zum abgerundeten Rechteck (negativ: innen)
  const sdBox = (px, py, x0, y0, x1, y1, r) => {
    const qx = Math.abs(px - (x0 + x1) / 2) - (x1 - x0) / 2 + r;
    const qy = Math.abs(py - (y0 + y1) / 2) - (y1 - y0) / 2 + r;
    return Math.hypot(Math.max(qx, 0), Math.max(qy, 0)) + Math.min(Math.max(qx, qy), 0) - r;
  };

  // Druckrand: um die wachsende Fläche, am breitesten mitten in der Bewegung, am Anfang und Ende unsichtbar
  const drawHalo = (cv, ins, rad, p, color) => {
    const { ctx, w, h } = htFit(cv);
    if (!htOn() || p <= 0.002 || p >= 0.998 || !w) return;
    const pitch = htPitch(w);
    const rowH = pitch * 0.866;
    const band = (w < 700 ? 28 : 58) * (0.35 + 0.65 * Math.sin(Math.PI * Math.min(1, p * 1.1)));
    ctx.globalAlpha = Math.min(0.45, 0.16 + htNum('--dc-ht-strength', 0.3)) * Math.min(1, p * 10) * Math.min(1, (1 - p) * 12);
    ctx.fillStyle = color;
    const x0 = ins[3];
    const y0 = ins[0];
    const x1 = w - ins[1];
    const y1 = h - ins[2];
    ctx.beginPath();
    for (let gy = Math.max(0, Math.floor((y0 - band) / rowH)); gy * rowH <= Math.min(h, y1 + band); gy += 1) {
      const cy = gy * rowH;
      const off = gy & 1 ? pitch / 2 : 0;
      // Zeilen mitten an der Fläche: nur links und rechts von ihr rechnen
      const ranges = cy > y0 + rad && cy < y1 - rad ? [[x0 - band, x0 + 1], [x1 - 1, x1 + band]] : [[x0 - band, x1 + band]];
      ranges.forEach(([a, b]) => {
        for (let gx = Math.floor((a - off) / pitch); gx * pitch + off <= b; gx += 1) {
          const n = htHash(gx, gy);
          const j = htHash(gy + 7, gx + 3);
          // leichter Versatz je Punkt, damit das Raster nicht gestanzt wirkt
          const cx = gx * pitch + off + (j - 0.5) * pitch * 0.22;
          const py = cy + (n - 0.5) * pitch * 0.18;
          const d = sdBox(cx, py, x0, y0, x1, y1, rad);
          if (d <= 0.5) continue;
          const t = 1 - d / (band * htWobble(cx, py));
          if (t <= 0) continue;
          // nach außen fallen immer mehr Punkte weg
          if (n > t + 0.25) continue;
          const r = pitch * 0.34 * (0.25 + 0.75 * Math.pow(t, 1.2)) * (0.55 + 0.45 * j);
          if (r < 0.5) continue;
          ctx.moveTo(cx + r, py);
          ctx.arc(cx, py, r, 0, Math.PI * 2);
        }
      });
    }
    ctx.fill();
  };

  // Ecke unten links in der App: Punkte werden zur Ecke hin größer
  const drawCorner = (cv, color) => {
    const { ctx, w, h } = htFit(cv);
    if (!htOn() || !w || !h) return;
    const pitch = htPitch(window.innerWidth);
    const rowH = pitch * 0.866;
    const R = Math.hypot(w, h) * 0.9;
    ctx.globalAlpha = Math.min(0.4, htNum('--dc-ht-strength', 0.3) * 1.1);
    ctx.fillStyle = color;
    ctx.beginPath();
    for (let gy = 0; gy * rowH <= h + pitch; gy += 1) {
      const cy = h - gy * rowH;
      const off = gy & 1 ? pitch / 2 : 0;
      for (let gx = 0; gx * pitch + off <= w + pitch; gx += 1) {
        const cx = gx * pitch + off;
        const t = 1 - Math.hypot(cx, h - cy) / (R * htWobble(cx * 1.7, cy * 1.7));
        if (t <= 0) continue;
        const n = htHash(gx + 97, gy + 31);
        if (n > t + 0.2) continue;
        const r = pitch * 0.36 * Math.pow(t, 1.5) * (0.55 + 0.45 * n);
        if (r < 0.5) continue;
        ctx.moveTo(cx + r, cy);
        ctx.arc(cx, cy, r, 0, Math.PI * 2);
      }
    }
    ctx.fill();
  };

  /* =====================================================================================================================
     C. Section: der Button wächst beim Scrollen zur App
     Höhe der Section = Bildschirm + Strecke zum Aufziehen + Strecke, in der die App im Vollbild steht.
     ================================================================================================================== */
  const initSection = (sec) => {
    if (sec.__dcAsks) return;
    const surface = sec.querySelector('[data-dc-asks-surface]');
    const form = surface && surface.querySelector('form');
    const sticky = sec.querySelector('.dc-asks__sticky');
    const pill = sec.querySelector('[data-dc-asks-pill]');
    const haloCv = sec.querySelector('.dc-asks__halo');
    const cornerCv = sec.querySelector('.dc-asks__corner');
    if (!surface || !form || !sticky || !pill) return;
    sec.__dcAsks = true;

    let full = false;
    const isStatic = () => reduce.matches;
    const app = createApp(surface, form, { active: () => full || isStatic() });
    app.start(sec.getAttribute('data-entry') || 'start', false, { silent: true });
    const back = app.returned();
    app.render();
    if (back && back.error) app.statusEl.textContent = tx('returned_error', { reason: back.error });

    const G = { top: 0, expand: 1, hold: 1, w: 0, h: 0, pill: null };
    const measure = () => {
      // Den Button in Ruhe messen: Überschrift und Button gleiten beim Aufziehen nach oben (--p). Würde mitten im
      // Scrollen gemessen (Browserleiste am Handy, Größenänderung, spät geladene Schrift), säße die Fläche danach versetzt.
      const prevP = sec.style.getPropertyValue('--p');
      sec.style.setProperty('--p', '0');
      const s = sticky.getBoundingClientRect();
      const b = pill.getBoundingClientRect();
      sec.style.setProperty('--p', prevP || '0');
      G.w = s.width;
      G.h = s.height;
      G.pill = { top: b.top - s.top, left: b.left - s.left, right: s.right - b.right, bottom: s.bottom - b.bottom, r: b.height / 2 };
      G.expand = parseFloat(getComputedStyle(sec).getPropertyValue('--asks-expand')) * G.h / 100 || G.h * 0.8;
      G.hold = sec.offsetHeight - G.h - G.expand;
      G.top = sec.getBoundingClientRect().top + window.scrollY;
      G.bg = getComputedStyle(surface).backgroundColor;
      if (cornerCv) drawCorner(cornerCv, getComputedStyle(surface).color);
    };

    const setFull = (on) => {
      if (on === full) return;
      full = on;
      form.inert = !on;
      sec.classList.toggle('is-full', on);
    };

    let raf = 0;
    const frame = () => {
      raf = 0;
      if (isStatic()) return;
      const r = sec.getBoundingClientRect();
      if (r.bottom < -50 || r.top > window.innerHeight + 50) return;
      const p = Math.min(1, Math.max(0, -r.top / G.expand));
      // Weicher Lauf: Anfang und Ende ruhig
      const e = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
      const b = G.pill;
      const k = 1 - e;
      // Ecken: erst Pille, dann Bühnen-Radius, auf der letzten Strecke eckig
      const rad = e < 0.82 ? Math.max(28, b.r * k) : 28 * (1 - (e - 0.82) / 0.18);
      const ins = [b.top * k, b.right * k, b.bottom * k, b.left * k];
      surface.style.clipPath = `inset(${ins.map((v) => v.toFixed(1) + 'px').join(' ')} round ${Math.max(0, rad).toFixed(1)}px)`;
      if (haloCv) drawHalo(haloCv, ins, Math.max(0, rad), p, G.bg);
      sec.style.setProperty('--p', p.toFixed(4));
      sec.classList.toggle('is-past', p > 0.3);
      setFull(p >= 0.995);
    };
    const schedule = () => { if (!raf) raf = requestAnimationFrame(frame); };
    const relayout = () => { measure(); schedule(); };

    // Scrollposition, in der die App ruhig im Vollbild steht (Anfang der Halte-Strecke plus etwas Luft)
    const fullY = () => G.top + G.expand + Math.min(G.hold * 0.25, 120);
    const goFull = (focus) => {
      measure();
      window.scrollTo({ top: fullY(), behavior: reduce.matches ? 'auto' : 'smooth' });
      if (!focus) return;
      let n = 0;
      const wait = () => { if (full || n > 60) app.focusHeading(); else { n += 1; setTimeout(wait, 50); } };
      wait();
    };

    if (isStatic()) {
      sec.classList.add('is-live', 'is-static');
      full = true;
      measure();
      window.addEventListener('resize', measure);
    } else {
      sec.classList.add('is-live');
      form.inert = true;
      measure();
      frame();
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', relayout);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(relayout);
      window.addEventListener('load', relayout, { once: true });
    }
    pill.addEventListener('click', (e) => {
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      if (isStatic()) { app.focusHeading(); return; }
      goFull(true);
    });

    // Links auf den Anker der Section (#anfrage) führen direkt in die offene App
    if (sec.id) {
      document.addEventListener('click', (e) => {
        const a = e.target.closest && e.target.closest('a[href^="#"]');
        if (!a || a.getAttribute('href') !== '#' + sec.id || e.defaultPrevented) return;
        e.preventDefault();
        goFull(true);
      });
      if (location.hash === '#' + sec.id) window.addEventListener('load', () => goFull(false), { once: true });
    }
    if (back) window.addEventListener('load', () => { if (!isStatic()) goFull(true); else app.focusHeading(); }, { once: true });

    // Handy: öffnet die Tastatur, kann die Seite springen. Die App bleibt dann im Vollbild stehen.
    form.addEventListener('focusin', () => {
      if (isStatic()) return;
      setTimeout(() => {
        const y = window.scrollY;
        const min = G.top + G.expand;
        const max = G.top + G.expand + G.hold;
        if (y < min - 2 || y > max + 2) window.scrollTo({ top: Math.min(max, Math.max(min, y)), behavior: 'auto' });
      }, 350);
    });
  };

  const initSections = (scope = document) => scope.querySelectorAll('[data-dc-asks]').forEach(initSection);

  initOverlay();
  initSections();
  document.addEventListener('shopify:section:load', (e) => initSections(e.target));
})();
